import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";
import { createGenerateReportHandler } from "../reports/sagas";

import {
  iataFetchError,
  iataFetchRequest,
  iataFetchSuccess,
  reportGeneratorTaskCreateRequest,
  tableFetchError,
  tableFetchRequest,
  tableFetchSuccess,
} from "./actions";
import { AuctionActionTypes } from "./types";

export function* handleAuctionItemsFetch(action: ReturnType<typeof tableFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const res = yield call(callGet, "/auction/", action.payload, source.token);
    yield put(tableFetchSuccess(res.data));
  } catch (err) {
    yield put(tableFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handleAuctionIataFetch(action: ReturnType<typeof iataFetchRequest>): SagaIterator {
  try {
    const { iata, ...payload } = action.payload;
    const res = yield call(callGet, `/auction/${iata}/`, payload);
    yield put(iataFetchSuccess({ items: res.data, iata }));
  } catch (err) {
    yield put(iataFetchError(err.message));
  }
}

const handleAuctionReportFetch = createGenerateReportHandler<ReturnType<typeof reportGeneratorTaskCreateRequest>>(
  "/auction/report/"
);

function* watchAuctionSagas(): SagaIterator {
  yield takeLatest(AuctionActionTypes.TABLE_FETCH_REQUEST, handleAuctionItemsFetch);
  yield takeLatest(AuctionActionTypes.IATA_FETCH_REQUEST, handleAuctionIataFetch);
  yield takeLatest(AuctionActionTypes.GENERATE_REPORT_REQUEST, handleAuctionReportFetch);
}

export default watchAuctionSagas;
